import { render, staticRenderFns } from "./P49.vue?vue&type=template&id=3774b674&scoped=true"
import script from "./P49.ts?vue&type=script&lang=ts&external"
export * from "./P49.ts?vue&type=script&lang=ts&external"
import style0 from "./P49.vue?vue&type=style&index=0&id=3774b674&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3774b674",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3774b674')) {
      api.createRecord('3774b674', component.options)
    } else {
      api.reload('3774b674', component.options)
    }
    module.hot.accept("./P49.vue?vue&type=template&id=3774b674&scoped=true", function () {
      api.rerender('3774b674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/pages/P49/P49.vue"
export default component.exports